import { EventsPage } from './pages';

export const eventsRoutes = [
  {
    path: 'events',
    component: EventsPage,
    requiredPermission: 'events.view',
  },
];
